﻿import $ from "jquery";

export enum MovingDirection {
    Up,
    Down
}

export abstract class EditableItemList<T> {
    protected divElementId!: string;
    protected itemList!: Array<T>;

    protected init(divElementId: string, insertButtonId: string): void {
        this.divElementId = divElementId;

        if ($(`#${divElementId}`)[0] !== undefined) {
            this.drawInsertItemButton(insertButtonId);
            this.drawItems();
        }
    }

    protected abstract drawItem(item: T, itemId: number);

    protected abstract addNewItem();

    protected drawItems() {
        for (let i = 0; i < this.itemList.length; i++) {
            this.drawItem(this.itemList[i], i);
        }
    }

    protected drawInsertItemButton(id: string) {
        const createButtonElement = "<div class='field'>" +
            "<div class='control'>" +
            "<button id='"+id+"' class='button' data-tooltip='Eingabefeld hinzufügen'>" +
            "<span class='icon is-small'>" +
            "<i class='fas fa-plus'></i>" +
            "</span>" +
            "</button>" +
            "</div>" +
            "</div>";

        $(`#${this.divElementId}`).after(createButtonElement);
        $("#"+id).click((e) => {
            e.preventDefault();
            this.addNewItem();
            this.redrawItems();
        });
    }

    protected redrawItems() {
        $(`#${this.divElementId}`).empty();
        this.drawItems();
    }

    protected moveItem(direction: MovingDirection, itemId: number) {
        if (itemId === 0 && direction === MovingDirection.Up ||
            itemId === this.itemList.length - 1 && direction === MovingDirection.Down) {
            return;
        }

        const newItemList = new Array<T>();
        if (direction === MovingDirection.Up) {
            for (let i = 0; i < itemId - 1; i++) {
                newItemList.push(this.itemList[i]);
            }
            newItemList.push(this.itemList[itemId]);
            newItemList.push(this.itemList[itemId - 1]);
            for (let i = itemId + 1; i < this.itemList.length; i++) {
                newItemList.push(this.itemList[i]);
            }
        } else {
            for (let i = 0; i < itemId; i++) {
                newItemList.push(this.itemList[i]);
            }
            newItemList.push(this.itemList[itemId + 1]);
            newItemList.push(this.itemList[itemId]);
            for (let i = itemId + 2; i < this.itemList.length; i++) {
                newItemList.push(this.itemList[i]);
            }
        }

        this.itemList = newItemList;
    }
}